// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2l_ts","modalForm":"UpgradeEpcsModal_modalForm__2FOG_","modalFooter":"UpgradeEpcsModal_modalFooter__266jG"};